import axios from "axios";

function getHeaderValue(headers, name) {
  if (!headers) return undefined;
  // Axios v1 uses AxiosHeaders with .get/.set
  if (typeof headers.get === "function") return headers.get(name);
  return headers[name];
}

function setHeaderValue(headers, name, value) {
  if (!headers) return;
  if (typeof headers.set === "function") {
    headers.set(name, value);
    return;
  }
  headers[name] = value;
}

function generateIdempotencyKey() {
  try {
    // Modern browsers
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch {
    // ignore
  }

  // Fallback: not cryptographically strong, but fine for idempotency keys.
  const rand = Math.random().toString(16).slice(2);
  const ts = Date.now().toString(16);
  return `idem_${ts}_${rand}`;
}

const httpClient = axios.create();

httpClient.interceptors.request.use((config) => {
  const method = String(config?.method || "get").toLowerCase();
  const isMutation = method !== "get" && method !== "head" && method !== "options";
  if (!isMutation) return config;

  // Normalize header object
  config.headers = config.headers || {};

  // Don't overwrite if a caller explicitly provided a key
  const hasKey = Boolean(
    getHeaderValue(config.headers, "Idempotency-Key") ||
      getHeaderValue(config.headers, "idempotency-key")
  );

  if (!hasKey) {
    setHeaderValue(config.headers, "Idempotency-Key", generateIdempotencyKey());
  }

  return config;
});

export default httpClient;

